import { NgClass } from '@angular/common'
import { Component, Input } from '@angular/core'
import { TranslatePipe } from '@ngx-translate/core'

import { BranchProgressState } from '../../../models/branch.model'
import {
  PROCESS_STATUS,
  ProcessStatus,
} from '../../upload-file/upload-file.model'

export type ProcessBarSizes = 'default' | 'small' | 'large'

@Component({
  selector: 'app-process-bar',
  standalone: true,
  imports: [TranslatePipe, NgClass],
  templateUrl: './process-bar.component.html',
})
export class ProcessBarComponent {
  @Input() public size: ProcessBarSizes = 'default'
  @Input() public processState?: BranchProgressState

  protected readonly PROCESS_STATUS = PROCESS_STATUS
  protected processIndex: number =
    PROCESS_STATUS.indexOf(this.processState as ProcessStatus) + 1
}
